import template from './registry.html';
import controller from './registry.controller';

let registryComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default registryComponent;
